<template>
  <div>
    <PessoaJuridica
      ref="pessoaJuridica"
      v-model="parceiro.pessoa_juridica"
      :optional-fields="optionalFieldsCNPJ"
    />

    <b-row>
      <b-col cols="12">
        <b-form-group label="IP permitido">
          <b-form-input
            v-model="parceiro.urls[0]"
            name="url"
            type="text"
            placeholder="IP com permissão de acesso"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <template v-if="false">
        <b-col cols="12" sm="6">
          <b-form-group label="Situação">
            <b-form-checkbox v-model="parceiro.ativo" switch name="ativo">
              {{ situationLabel }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6">
          <b-form-group label="Login integrado">
            <b-form-checkbox
              v-model="parceiro.login_integrado"
              switch
              name="login_integrado"
            >
              Login integrado
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6">
          <b-form-group label="Acesso exclusivo">
            <b-form-checkbox v-model="parceiro.apenas_acesso_exclusivo" switch>
              Acesso exclusivo
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import { useNamespacedState } from "vuex-composition-helpers";
import useVuelidate from "@vuelidate/core";

import PessoaJuridica from "@/components/Form/PessoaJuridica.vue";

export default defineComponent({
  components: { PessoaJuridica },
  setup() {
    const parceiroStates = useNamespacedState("parceiros", ["parceiro"]);
    const pessoaJuridica = ref(null);
    const optionalFieldsCNPJ = ["razao_social", "cnpj"];
    const rules = {
      parceiro: {},
    };

    const v$ = useVuelidate(rules, parceiroStates);
    const situationStatus = computed(() =>
      parceiroStates.parceiro.value?.ativo ? "ativo" : "inativo"
    );
    const situationLabel = computed(() => `Usuário ${situationStatus.value}`);

    function validateState(name) {
      const $field = Reflect.get(v$.value?.parceiro, name) || {};

      return $field.$dirty ? !$field.$error : null;
    }

    function isValid() {
      v$.value?.parceiro?.$touch?.();

      return (
        !v$.value?.parceiro?.$anyError && !!pessoaJuridica.value?.isValid?.()
      );
    }

    return {
      ...parceiroStates,
      isValid,
      optionalFieldsCNPJ,
      pessoaJuridica,
      situationLabel,
      situationStatus,
      validateState,
    };
  },
});
</script>
